import { Pipe, PipeTransform } from "@angular/core";
import { LanguageService } from "../services/language.service";

@Pipe({
  name: "time"
})
export class TimePipe implements PipeTransform {

  constructor(private languageService: LanguageService) {}

  transform(value: number, type: string = "m"): string {
    const isMinutes = !type || type.toLowerCase() === "m";
    const isSeconds = !isMinutes && type.toLowerCase() === "s";

    return isMinutes ? this.getTimeFormattedInMinutes(value) : this.getTimeFormattedInSeconds(value);
  }

  private getTimeFormattedInMinutes(value: number): string {
   return  `${Math.floor(value / 60)} ${this.languageService.LNG("Label.ShortHours")} ${value % 60} ${this.languageService.LNG("Label.ShortMinutes")}`
  }

  private getTimeFormattedInSeconds(value: number): string {
    const hours = Math.floor(value / 3600);
    value %= 3600;
    const minutes = Math.floor(value / 60);
    const seconds = value % 60;

    return  `${hours} ${this.languageService.LNG("Label.ShortHours")} ${minutes} ${this.languageService.LNG("Label.ShortMinutes")} ${seconds} ${this.languageService.LNG("Label.ShortSeconds")}`
  }
}
